import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { persistReducer } from 'redux-persist';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import authReducer from '../views/Login/reducer';
import eventReducer from '../views/Events/reducer';
import notificationReducer from '../views/Notifications/reducer';
import mooseReducer from '../views/Moose/reducer';
import rewardReducer from '../views/Rewards/reducer';
import userReducer from '../views/Users/reducer';
import friendReducer from '../views/Friends/reducer';
import newsReducer from '../views/Newsletter/reducer';
import sportsReducer from '../views/SportsNews/reducer';
import seasonReducer from '../views/Season/reducer';
import shardReducer from '../views/Shards/reducer';
import lottoReducer from '../views/Lotto/reducer';
import couponReducer from '../views/Coupons/reducer';
import locationReducer from '../views/Locations/reducer';
import apiReducer from '../views/Automation/reducer';
import themeReducer from '../views/General/reducer';
import homeReducer from '../views/Home/reducer';

const config = {
    key: 'root',
    storage,
};

const combinedReducer = combineReducers({
  routing: routerReducer,
  form: formReducer,
  authReducer,
  eventReducer,
  notificationReducer,
  mooseReducer,
  rewardReducer,
  userReducer,
  friendReducer,
  newsReducer,
  sportsReducer,
  seasonReducer,
  shardReducer,
  lottoReducer,
  couponReducer,
  locationReducer,
  apiReducer,
  themeReducer,
  homeReducer,
});

const appReducer = persistReducer(config, combinedReducer);

export default appReducer;
